import { getVariableSyntax } from "@/assets/js/appFunc";
// Plugins config
export const diagramPlugins = (state) => state.diagramPlugins;

// Diagram config
export const diagramConfigData = (state) => state.diagramConfigData;
// Configure Api - all Api
export const setAllAppi = (state) => state.setAllAppi;

export const copyOfInitialContentDiagram = (state) => state.copyOfInitialContentDiagram;

export const copyOfInitialConnectorsDiagram = (state) => state.copyOfInitialConnectorsDiagram;

export const copyOfInitialMessagesDiagam = (state) => state.copyOfInitialMessagesDiagam;

export const lastPluginCreated = (state) => state.lastPluginCreated;

export const getExternalMapReqData = (state) => state.externalMapReqData;

export const apiParam = (state) => state.apiParam;
export const getHasNewComments = (state) => state.hasNewComments;
export const getExternalDraftDataSMS = (state) => state.externalDraftDataSMS;
export const getExternalDraftDataEmail = (state) => state.externalDraftDataEmail;
export const getExternalDraftDataEmailAuth = (state) => state.externalDraftDataEmailAuth;
export const setAllResponse = (state) => state.setAllResponse;
export const setAllResponseCallApi = (state) => state.setAllResponseCallApi;
export const setAllErrors = (state) => state.setAllErrors;
export const setModelForProcessDefinition = (state) => state.setModelForProcessDefinition;
export const getProcessWithError = (state) => state.processWithError;
export const setAllRequest = (state) => state.setAllRequest;
export const setAllRequestCallApi = (state) => state.setAllRequestCallApi;
export const externalTask = (state) => state.externalTask;

// Diagram data
export const selectedPluginCode = (state) => state.selectedPluginCode;

export const selectedPluginUuid = (state) => state.selectedPluginUuid;

export const selectedPluginData = (state) => {
    let pluginData;
    if (state.selectedPluginCode) {
        pluginData = state.diagramPlugins.find(el => el.id === state.selectedPluginCode);
    }
    state.selectedPluginData = pluginData || [];
    return state.selectedPluginData;
};

export const selectedPluginConfigData = (state) => {
    let lastSelectedPluginConfig;
    if (state.selectedPluginUuid) {
        lastSelectedPluginConfig = state.diagramConfigData.content.find(el => el.uuid === state.selectedPluginUuid);
    }
    return lastSelectedPluginConfig || {};
};

export const pluginConfigData = (state) => (uuid, type) => {
    const data = state.diagramConfigData[type || "content"].find(el => el.uuid === uuid);
    return data || {};
};

export const diagramData = (state) => state.diagramData;

export const getIsFromResponse = (state) => state.isFromResponse;

export const configCache = (state) => state.configCache;

export const getParallelHTCheckbox = (state) => state.parallelHTCheckbox;

export const guiForProcessDefinition = (state) => state.guiForProcessDefinition;

function applyFilters(filters, field) {
    let allowed = false;

    if (filters) {
        // maybe this field does not match type but has children
        if (filters.showOnlyType && Object.keys(filters.showOnlyType).length && !field.fields) {
            const { type } = field;

            if (filters.showOnlyType.hasOwnProperty(type)) {
                if (filters.showOnlyType[type] === false) {
                    allowed = false; // stop this iteration
                } else {
                    allowed = true;
                }
            } else {
                allowed = false;
            }
        } else if (filters.showOnlyType && Object.keys(filters.showOnlyType).length && field.fields) {
            allowed = true;
        } else {
            allowed = false;
        }

        if (allowed && filters.withProps && Object.keys(filters.withProps).length !== 0) {
            allowed = false; // stop this iteration if we have withProps filters
            const findKey = Object.keys(filters.withProps).find(key => field[key]);
            if (findKey) {
                allowed = true;
            }
        }
    }

    return allowed;
}

/**
 *
 * @param {Object} field  - field info
 * @param {String} fullPath - full path to this field
 * @param {Object} filters - object used to return only what's needed
 * @param {String} source - source of object, MOD or VAR
 * @returns {Array}
 */
function getAllEmbeddedFields(field, fullPath, filters, source, generateVarChildren, parent) {
    const embeddedFields = [];

    if (!filters) {
        filters = {};
    }

    if (field.isList && (!filters.showOnlyType || !filters.showOnlyType.Attachment)) {
        const variableSyntax = getVariableSyntax(source, field.type);
        if (generateVarChildren && (!field.isCat || (field.isCat && !filters.hideCatalogFields))) {
            field.fields.forEach(fieldElement => {
                embeddedFields.push({
                    ...fieldElement,
                    type: fieldElement.type,
                    dataType: fieldElement.dataType || "",
                    itemFromList: true,
                    parentOfList: field.name,
                    name: fieldElement.name,
                    parent: parent.name,
                    variable: `${variableSyntax.variableStart + fullPath}.${fieldElement.name}${variableSyntax.variableEnd}`
                });
            });
        } else {
            embeddedFields.push({
                ...field,
                type: field.type,
                dataType: field.dataType || "",
                name: fullPath,
                parent: field.name,
                variable: variableSyntax.variableStart + fullPath + variableSyntax.variableEnd
            });
        }
    } else if (!field.isCat || (field.isCat && !filters.hideCatalogFields)) {
        for (let i = 0; i < field.fields.length; i++) {
            const el = field.fields[i];
            if (!(el.isList && filters.showOnlyType && filters.showOnlyType.Attachment) && applyFilters(filters, el)) {
                if (el.fields && el.fields.length && !el.isList && (!field.isCat || (field.isCat && !filters.hideCatalogFields))) {
                    let name = null;
                    let emb = null;
                    name = fullPath ? `${fullPath}.${el.name}` : el.name;
                    emb = getAllEmbeddedFields(el, name, filters, source);
                    if (embeddedFields && embeddedFields.length) {
                        embeddedFields.push(...emb);
                    }
                } else {
                    const variableSyntax = getVariableSyntax(source, el.type || "");
                    embeddedFields.push({
                        ...el,
                        type: el.type,
                        dataType: el.dataType || "",
                        name: `${fullPath}.${el.name}`,
                        parent: field.name,
                        variable: `${variableSyntax.variableStart + fullPath}.${el.name}${variableSyntax.variableEnd}`
                    });
                }
            }
        }
    } else {
        const variableSyntax = getVariableSyntax(source, field.type);

        embeddedFields.push({
            ...field,
            type: field.type,
            dataType: field.dataType || "",
            name: fullPath,
            parent: field.name,
            variable: variableSyntax.variableStart + fullPath + variableSyntax.variableEnd
        });
    }

    return embeddedFields;
}
function getVariablesModelList(classDetails, field, el, elemListField) {
    const variableSyntax = getVariableSyntax("MOD", (elemListField ? elemListField.type : field.type));
    classDetails.fields.push({
        ...(elemListField || field),
        itemFromList: !!elemListField,
        parentOfList: elemListField ? field.name : null,
        name: elemListField ? elemListField.name : `${el.name}.${field.name}`,
        parent: el.name,
        variable: `${variableSyntax.variableStart + el.name}.${field.name}${elemListField ? (`.${elemListField.name}`) : ""}${variableSyntax.variableEnd}`
    });
}
/**
 * Returns data model for current process filtered
 * @param {Object} filters
 * @param {Object} filters.showOnlyType - object with items to show/hide. Should be of form { Attachment: true, String: true }
 * @param {Object} filters.withProps - object with items to show/hide. Should be of form { isList: true }
 * @param {Object} filters.withProps - object with items to show/hide. Should be of form { generateVariablesForChildren: true }
 * @param {Object} filters.showStandaloneClassOfType - string with name of class to add to list. Should be of form 'className'
 * @param {Object} filters.hideCatalogFields - boolean - do not expand catalog fields
 */
export const modelForProcessDefinition = (state) => (filters) => {
    const model = [];
    const classes = state.modelForProcessDefinition.modelClasses;

    if (!classes) {
        return model;
    }

    if (!filters) {
        filters = {};
    }

    classes.forEach(el => {
        const classDetails = {
            name: el.name,
            fields: []
        };

        if (filters && (filters.showStandaloneClassOfType === el.name || filters.hideCatalogFields
            || (filters.withProps && filters.withProps.isBCReady && el.isBCReady))) {
            classDetails.fields = el.fields;
            model.push(classDetails);
            return;
        }

        if (el.fields) {
            for (let i = 0; i < el.fields.length; i++) {
                const field = el.fields[i];
                if (applyFilters(filters, field)) {
                    let goOn = true;
                    if (filters && !(field.isList && filters.showOnlyType && filters.showOnlyType.Attachment)) {
                        if (field.isList && filters.withProps && filters.withProps.isList) {
                            classDetails.fields.push(...getAllEmbeddedFields(field, `${el.name}.${field.name}`,
                                null, "MOD", filters.withProps.generateVariablesForChildren, el));
                            goOn = false;
                        }
                    }
                    if (goOn) {
                        if (field.fields && field.fields.length
                            && (!field.isCat || (field.isCat && !filters.hideCatalogFields))) {
                            classDetails.fields.push(...getAllEmbeddedFields(field, `${el.name}.${field.name}`, filters, "MOD"));
                        } else {
                            getVariablesModelList(classDetails, field, el);
                        }
                    }
                }
            }
        }

        if (classDetails.fields.length) {
            model.push(classDetails);
        }
    });

    return model;
};

export const variables = (state) => {
    const vars = [];

    state.variables.modelVariables.forEach(el => {
        const classDetails = {
            name: el.name,
            fields: []
        };

        if (el.fields) {
            el.fields.forEach(field => {
                if (field.fields && field.fields.length) {
                    classDetails.fields.push(...getAllEmbeddedFields(field, `${el.name}.${field.name}`, null, "VAR"));
                } else {
                    const variableSyntax = getVariableSyntax("VAR", field.type);

                    classDetails.fields.push({
                        type: field.type,
                        name: `${el.name}.${field.name}`,
                        parent: el.name,
                        variable: `${variableSyntax.variableStart + el.name}.${field.name}${variableSyntax.variableEnd}`
                    });
                }
            });
        } else {
            const variableSyntax = getVariableSyntax("VAR", el.type);

            classDetails.fields.push({
                type: el.type,
                name: `${el.name}`,
                parent: el.name,
                variable: variableSyntax.variableStart + el.name + variableSyntax.variableEnd
            });
        }
        vars.push(classDetails);
    });

    return vars;
};
export const externalStartUrl = (state) => state.externalStartUrl;
export const scDetailsFunction = (state) => state.scDetailsFunction;
export const scDetailsEvent = (state) => state.scDetailsEvent;
export const exposeStartUrl = (state) => state.exposeStartUrl;
export const getProcesses = (state) => state.activeProcesses;

export const getExternalTaskRegularMessages = (state) => state.externalTaskRegularMessages;

export const getExternalTaskDynamicMessages = (state) => state.externalTaskDynamicMessages;

export const componentsConfig = (state) => state.componentsConfig;

export const getCatalogByName = (state) => (catalogName) => state.modelForProcessDefinition.modelCatalogs.find(el => el.name === catalogName);

export const getDiagramStateModifications = (state) => state.diagramStateModifications;

export const getConnectorsValidation = (state) => state.connectorsValidation;

// export warnings list - publish application
export const getWarningsList = (state) => state.warningOnApp;

// contain all timeline tasks details
export const getAllTimelineTaskDetails = (state) => state.allTimelineTaskDetails;

// contain all timeline approval matrix tasks details
export const getAllTimelineAppLevelDetails = (state) => state.allTimelineAppLevelDetails;
